<template>
  <div class="content-warp main-width paddingtb20">
    <div class="content" v-if="!hidden">
      <div class="title">
        <label v-if="matchInfo.personalDataHide === 'SHOW'">参赛人数：<span>{{ joinTotalPersonNum }}</span></label>
        <label>参赛人次：<span>{{ joinTotalPersonTimes }}</span> </label>
      </div>
      <div class="table-warp">
        <div class="table-list">
          <div class="row table-header">
            <div class="col col-1 text-center">序号</div>
            <div class="col col-5">机构</div>
            <div class="col col-2 text-center">参赛人数</div>
            <div class="col col-2 text-center">参赛人次</div>
            <div class="col col-2 text-center">机构类型</div>
          </div>
          <div class="row" @click="detailsClick(item)" v-for="(item,index) in data" :key="index">
            <div class="col col-1 text-center">{{index+1}}</div>
            <div class="col col-5">
              <img :src="item.head" class="table-logo">
              {{item.name}}
            </div>
            <div class="col col-2 text-center">{{item.joinPersonNum}}</div>
            <div class="col col-2 text-center">{{item.joinPersionTimes}}</div>
            <div class="col col-2 text-center">{{matchFun.agencyTypeText(item.joinerType)}}</div>
          </div>
          <div class="row-empty" v-if="data.length<=0">
            <a-empty
              :image="emptyImg"
              :image-style="{height: '30px'}">
              <span slot="description" style="color:#bbbaba;">暂无数据</span>
            </a-empty>
          </div>
        </div>
      </div>
    </div>
    <div class="content" style="margin-top: 50px;height: 100px;" v-else>
      <a-empty
        :image="hiddenImg"
        :image-style="{height: '30px'}">
        <span slot="description" style="color:#bbbaba;">
          <!-- 主办方隐藏了参赛数据 -->
          </span>
      </a-empty>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'MatchAgency',
  created () {
    this.findData()
  },
  computed: {
    ...mapState({
      matchInfo: state => state.match.matchInfo
    })
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId || 1,
      programId: this.$route.query.programId || 1,
      matchFun: matchFun,
      joinTotalPersonNum: 0, // 参赛人数
      joinTotalPersonTimes: 0, // 参赛人次
      hiddenImg: require('../assets/hidden.png'),
      data: [],
      hidden: false,
      emptyImg: require('../assets/empty.png')
    }
  },
  methods: {
    findData () {
      this.$api.match.queryJoinAgencyData({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.hidden = false
          this.data = res.data
          this.data.forEach(item => {
            this.joinTotalPersonNum += Number(item.joinPersonNum)
            this.joinTotalPersonTimes += Number(item.joinPersionTimes)
          })
        } else if (res.status === 1102002) {
          this.hidden = true
        } else {
          this.hidden = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    detailsClick (item) {
      this.$router.push({path: '/AgencyDetail', query: {matchId: this.matchId, programId: this.programId, agencyId: item.joinerId, type: item.joinerType, head: item.head, name: item.name}})
    }
  }
}
</script>
<style lang="scss" scoped>
.main-width {
  width:1200px;
  margin-left:auto;
  margin-right:auto;
}
.table-list {
 background-color:#fff
}
.table-list .table-header {
 color:#000;
 font-weight:700;
 background-color:#e5e5e5;
 border-bottom:1px solid #e8e8e8
}
.table-list .table-header .col {
 padding:16px 8px!important
}
.table-list .table-header img {
 max-width:20px
}
.table-list .col {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 padding:8px
}
.table-list .col-1 {
 -webkit-box-flex:1;
 -ms-flex:1;
 flex:1
}
.table-list .col-2 {
 -webkit-box-flex:2;
 -ms-flex:2;
 flex:2
}
.table-list .col-3 {
 -webkit-box-flex:3;
 -ms-flex:3;
 flex:3
}
.table-list .col-4 {
 -webkit-box-flex:4;
 -ms-flex:4;
 flex:4
}
.table-list .col-5 {
 -webkit-box-flex:5;
 -ms-flex:5;
 flex:5
}
.table-list .col-6 {
 -webkit-box-flex:6;
 -ms-flex:6;
 flex:6
}
.table-list .text-center {
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 text-align:center
}
.table-list .row {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-orient:horizontal;
 -webkit-box-direction:normal;
 -ms-flex-direction:row;
 flex-direction:row;
 border-bottom:1px solid #e8e8e8;
 min-height:60px
}
.table-list .row .check-table {
 margin-right:5px
}
.table-list .row .table-logo {
 width:45px;
 height:45px;
 border-radius:50%;
 margin-right:5px;
 border:1px solid #f8f8f8;
 cursor:pointer
}
.table-list .row .btn-del,
.table-list .row .btn-jj,
.table-list .row .btn-tg {
 cursor:pointer;
 border:1px solid #e8e8e8;
 margin:0 5px;
 padding:0 5px;
 border-radius:2px
}
.table-list .row .btn-tg {
 color:#42ad00
}
.table-list .row .btn-tg:hover {
 color:#fff;
 border:1px solid #42ad00;
 background-color:#42ad00
}
.table-list .row .btn-jj {
 color:#f14f2b
}
.table-list .row .btn-jj:hover {
 color:#fff;
 border:1px solid #f14f2b;
 background-color:#f14f2b
}
.table-list .row .btn-del {
 color:#000
}
.table-list .row .btn-del:hover {
 color:#fff;
 border:1px solid #000;
 background-color:#000
}
.table-list .row-empty {
 color:rgba(0,0,0,.25);
 border:1px solid #e8e8e8;
 border-top:none;
 min-height:160px;
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 -webkit-box-orient:vertical;
 -webkit-box-direction:normal;
 -ms-flex-direction:column;
 flex-direction:column;
 background-color:#fff
}
  .content{
    .title{
      line-height: 50px;
      text-align: right;
      font-size: 14px;
      span{
        color: #b80000;
      }
    }
    .table-warp{
      min-height: 200px;
    }
    .table-list{
      .row{
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchAgency.vue